import React from 'react'
import About from "./../Components/About/About"
export const AboutPage = () => {
  return (
    <div>
        <About/>
    </div>
  )
}
